/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-quotes': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.5 9.375H3.819A5.625 5.625 0 016.25 5.537l1.119-.75L6.68 3.75l-1.119.75A6.875 6.875 0 002.5 10.219v4.156c0 .69.56 1.25 1.25 1.25H7.5c.69 0 1.25-.56 1.25-1.25v-3.75c0-.69-.56-1.25-1.25-1.25zm8.75 0h-3.681A5.625 5.625 0 0115 5.537l1.119-.75-.681-1.037-1.126.75a6.875 6.875 0 00-3.062 5.719v4.156c0 .69.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25v-3.75c0-.69-.56-1.25-1.25-1.25z"/>'
  }
})
